import { Grid as BaseGrid, styled } from '@mui/material'

export const Box = styled('div')`
  width: ${props => props.width};
  text-align: left;
`

export const Column = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
  }
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const Wrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
